import { render, staticRenderFns } from "./WarehouseUser.vue?vue&type=template&id=bb94a952&"
import script from "./WarehouseUser.vue?vue&type=script&lang=js&"
export * from "./WarehouseUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports